<template>
  <vx-card no-shadow>

    <div>
      <div class="vx-row mt-4">
        <div class="vx-col w-full">
          <h3>Preguntas Personalizadas del Proceso de Consulta</h3>
        </div>
        <div class="vx-col w-full">
          
        </div>
      </div>
      <vs-row vs-type="flex" vs-justify="center">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <code class="m-3 shadow" style="font-size: 15px;">{{questions.length}}/10</code>
        </vs-col>
      </vs-row>
      <div v-for="(question, key) in questions" :key="key">
        <div class="vx-row mt-4">
          <div class="vx-col w-1/3">
            <span>Nombre (Identificador Interno)</span>
          </div>
          <div class="vx-col w-1/3 ">
            <vs-input class="w-full" v-model="question.name" />
          </div>
          <div class="vx-col w-1/3 ">
            <div class="mt-2 flex">
              <vs-switch v-model="question.active" />
              <span class="ml-4">{{ question.active ? 'Activo' : 'Inactivo'}}</span>
            </div>
          </div>
        </div>
        <div class="vx-row mt-3">
          <div class="vx-col w-1/3">
            <span>Pregunta</span>
          </div>
          <div class="vx-col w-2/3 ">
            <vs-input class="w-full" v-model="question.title" />
          </div>
        </div>
        <div class="vx-row mt-3">
          <div class="vx-col w-1/3">
            <span>Placeholder</span>
          </div>
          <div class="vx-col w-2/3 ">
            <vs-textarea v-model="question.instructions" />
          </div>
        </div>
        <vs-row vs-type="flex" vs-justify="flex-end">
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="flex-end" vs-w="6">
            <vs-button class="" color="danger" type="filled" icon-pack="feather" icon="icon-x-circle" @click="delQuestion(key)"></vs-button>
          </vs-col>
        </vs-row>
        <vs-divider 
        class="mb-3"
        icon-pack="feather" :icon="question.active ? 'icon-check' : 'icon-x'" position="center" :color="question.active ? 'success' : 'danger'"
        ></vs-divider>
      </div>      
      <div class="vx-row mt-5">
        <div class="vx-col w-full">
          <div class="vx-row flex" style="justify-content: flex-end">
            <vs-button class="mr-4 my-3" color="success" type="filled" icon-pack="feather" icon="icon-plus-circle" @click="addQuestion">Agregar Pregunta</vs-button>
          </div>
        </div>
      </div>
      <vs-divider class="mt-1"></vs-divider>
    </div>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="saveQuestions">Guardar Cambios</vs-button>
      <!-- <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button> -->
    </div>
  </vx-card>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

export default {
  components: {
    flatPickr,
    vSelect
  },
  data () {
    return {
      questions: [],
      userData: {},
      show: true,
      show2: true,
      // Options
      formOptions: [
        'Texto',
        'Área de Texto',
        'Teléfono',
        'Correo',
        'Número',
        'Selector',
        'Si / No',
      ],
    }
  },
  methods: {
    delQuestion(indx){
      this.questions.splice(indx,1);
    },
    addQuestion(){
      var tempQuestion = new Object();
      tempQuestion.name = '';
      tempQuestion.title = '';
      tempQuestion.instructions = '';
      tempQuestion.active = true;
      if(this.questions.length <= 9){
        this.questions.push(tempQuestion);
      }  else {
          this.showAlert(
        "danger",
        "Límite de preguntas alcanzado",
        "Solo puedes agregar 10 preguntas"
        );
      }
      
    },
    saveQuestions(){
        var metaUpdateUser = {
          id: this.userData.id,
          meta: {...this.userData.meta, ...{'consultation_questions': this.questions}}
        };
        this.$store.dispatch('evolugy/updateUser', metaUpdateUser);
        this.showAlert(
        "success",
        "Preguntas Guardadas",
        "Preguntas Guardadas éxitosamente!"
        );
    },
     showAlert(color, title, text) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text,
      });
    },
  },
  created() {
    this.userData = JSON.parse(JSON.stringify(this.$store.state.AppActiveUser));
    if(this.userData.meta.consultation_questions){
      this.questions = this.userData.meta.consultation_questions;
    } 
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  }
}
</script>
